export default function getChosenJobLayout(layoutArray, id) {

    //If recieve error in cosole: "TypeError: Cannot read property 'find' of undefined" than the companyCode in the Req is wrong (recruitingREG, filter7, companyCode)
    //Either use a valid companyCode in the Req or add the companyCode to the appropriate companySpecificConfig
    return layoutArray.find(i => i.id === id)

  }